import React from 'react';

const contacts = [
    { label: 'Email', href: 'mailto:noah.forest@yahoo.com'},
    { label: 'GitHub', href: 'https://github.com/noah-forest'},
    { label: 'Itch.io', href: 'https://glumpis.itch.io/'},
];

export default function Contact() {
    return (
        <section id="contact" className="max-w-3xl px-4 py-2 pb-10">
            <div className="bg-black/90 rounded-xl border border-red-400/30 shadow-lg shadow-black/40 px-6 py-5">
                <h2 className="text-4xl font-bold text-white tracking-tight pl-2">Contact</h2>
                <hr className="mt-2 border-t-2 border-red-400 w-[9.5rem]" />
                <p className="text-gray-400 text-base italic mt-3">Best way to contact me is through Email.</p>

                <div className="bg-white/5 border border-red-400/10 rounded-lg p-5 mt-6">
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
                        {contacts.map(({ label, href, icon }) => (
                            <a
                            key={label}
                            href={href}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="bg-gray-800/80 hover:bg-gray-700 border border-transparent hover:border-red-400/40 rounded-lg p-3 text-white transition-all duration-200 hover:-translate-y-0.5 flex flex-col items-center justify-center text-center min-h-[3.5rem]" >
                            <h3 className="text-sm font-semibold">{label}</h3>
                </a>
                ))}
            </div>
        </div>
</div>
</section>
);
}